import type { TmsInvoiceRow } from '@numeo/types-main-web-app'
import { useInvoicingRowsStore } from '../../../invoicing/rowsStore'

/**
 * Reads one load's invoicing row again and patches the shared rows store, so the table, the drawer and a chat card all show the
 * same state. Resolves to the row, or undefined when the read fails (the caller keeps what it shows).
 */
export const refreshInvoicingRow = async (tabId: string, loadNumber: string): Promise<TmsInvoiceRow | undefined> => {
    try {
        await useInvoicingRowsStore.getState().refresh(tabId, [loadNumber])
        return useInvoicingRowsStore.getState().rows[loadNumber]
    } catch {
        return undefined
    }
}
